import { createContext } from 'react'
import { RootState } from 'typesafe-actions'

type TLoginUser = RootState['loginUser']

const LoginUserContext = createContext<TLoginUser>(null)

export default LoginUserContext
